import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {useQueryClient} from "react-query";
import SweetAlert from "react-bootstrap-sweetalert";
import {useSnackbar} from "notistack";

import FilterAndSearch from "../../components/FilterAndSearch";
import ProjectModal from "../../components/Modal/ProjectModal";
import Image from "../../components/Image";
import {Row, Col} from "../../components/Layout";
import {setProject} from "../../redux/session/sessionActions";
import {deleteElem, getErrorMessage, post, PROJECTS, put} from "../../service/Client";

import { projects as projectsConstants, roles } from '../../constants'
import { findCropByName } from "constants/Crops";
import { deleteIcon_over, deleteIcon_popUp, editIcon_over, editIcon_popUp } from 'img/icons'
import styles from './projectType.module.scss'


function ProjectPill({ project, onClick, onEdit, onDelete, showDss }) {
	let [isHover, setIsHover] = useState();
	let type = projectsConstants.types.find(t => t.name === project.projectTypeName) ?? projectsConstants.unknownType
	return <div
		onClick={onClick}
		onMouseOver={() => setIsHover(project.id)}
		onMouseOut={() => setIsHover(null)}
		className={styles.projectPill}>
			<div style={{paddingRight:"1rem"}}>{type && <img alt={type.name} src={isHover === project.id ? type.smallIconHover : type.smallIcon}/>}</div>
			<Col>
				<div>{project.name}</div>
				<div>{project.companyName}</div>
				{showDss && project.cropNames && <div>
					{project.cropNames.map(findCropByName).filter(c => !!c).map(c =>
						<span key={c.id} className={styles.dssElement}>
							<img alt={c.name} src={isHover === project.id ? c.iconHover : c.icon} />
						</span>
					)}
				</div>}
			</Col>
			{onEdit && <div style={{paddingLeft:"1rem"}}><Image
				src={editIcon_popUp}
				hover={editIcon_over}
				onClick={(e) => {
					e.stopPropagation();
					onEdit(project);
				}}
			/></div>}
			{onDelete && <div style={{paddingLeft:"1rem"}}><Image
				src={deleteIcon_popUp}
				hover={deleteIcon_over}
				onClick={(e) => {
					e.stopPropagation();
					onDelete(project);
				}}
			/></div>}
	</div>
}

export function ProjectListPage({projects, type, userRole}) {

	let [selected, setSelected] = useState(null);
	let [search, setSearch] = useState();
	let [alert, setAlert] = useState();
	let [projectOpen, setProjectOpen] = useState();
	let [projectEdit, setProjectEdit] = useState();
	let dispatch = useDispatch();
	let queryClient = useQueryClient()
	const {enqueueSnackbar} = useSnackbar();
	let data = projects.slice()
	let isSuperuser = userRole.name === roles.names.SUPER;

	function showError(e)  {
		enqueueSnackbar(getErrorMessage(e), {variant: "error"});
	}
	function saveProject(p) {
		setProjectOpen(false)
		setProjectEdit(undefined)
		let request = p.id ? put(`${PROJECTS}/${p.id}`, {body:p}) : post(PROJECTS, {body: p})
		request.then(() => queryClient.invalidateQueries("projects")).catch(showError)
	}

	function deleteProject(p) {
		setAlert(<SweetAlert
			warning
			showCancel
			cancelBtnText={"Annulla"}
			confirmBtnText="Ho capito, elimina"
			confirmBtnBsStyle="danger"
			title="Confermi?"
			onConfirm={() => deleteElem(`${PROJECTS}/${p.id}`).then(() => queryClient.invalidateQueries("projects")).catch(showError).finally(()=>setAlert(null))}
			onCancel={() => setAlert(null)}
			focusCancelBtn
		>
			{`Il progetto ${p.name} sarà eliminato definitivamente e non sarà più possibile recuperarlo`}
		</SweetAlert>)
	}

	let filterNames = projectsConstants.types.filter(t => !t.hidden).map(r => r.name)
	if (isSuperuser) filterNames.unshift('nascosti')
	let filter = selected || type?.name;
	data = data.filter(p => {
		if (!filter) {
			return !p.hidden
		} else if (filter !== 'nascosti') {
			return !p.hidden && p.projectTypeName === filter
		} else {
			return p.hidden
		}
	})
	if(search) data = data.filter(p => p.name.toLowerCase().includes(search.toLowerCase()) || (p.companyName||"").toLowerCase().includes(search.toLowerCase()))
	data.sort((a,b) => b.id-a.id)

	return <div>
		{!type && <FilterAndSearch
			filter={filterNames}
			onFilter={setSelected}
			onSearch={setSearch}
			addElement={isSuperuser ? () => setProjectOpen(true) : null}
			style={{marginTop: "1.5rem", marginBottom: "1.5rem"}}
			selected={selected}
		/>
		}
		<Row className={styles.space}>
			{
				data.map(p => <ProjectPill
					key={p.id}
					project={p}
					onClick={() => dispatch(setProject(p))}
					onEdit={isSuperuser ? () => setProjectEdit(p) : null}
					onDelete={isSuperuser ? () => deleteProject(p) : null}
					showDss={isSuperuser}
				/>)
			}
		</Row>
		<ProjectModal
			isOpen={!!(projectOpen || projectEdit)}
			onClose={() => {
				setProjectOpen(false);
				setProjectEdit(undefined);
			}}
			onSubmit={saveProject}
			defaultValue={projectEdit}
		/>
		{alert}
	</div>;
}
